/**
 * ============================================================================
 * AuditLog 模块 - 枚举定义
 * ============================================================================
 * 
 * 📋 文件职责：
 * - 定义审计日志相关的所有枚举类型
 * - 包含：AuditAction 等
 * 
 * 📖 对应后端：
 * - Model: backend/app/Models/SystemAuditLog.php (getActionTextAttribute方法)
 * - Service: backend/app/Services/AuditService.php
 * 
 * ⚠️ 注意事项：
 * - 枚举值必须与后端完全一致
 * - 每个枚举值必须添加中文注释
 * - 使用 TypeScript enum 而不是 type
 * 
 * 🔄 更新时机：
 * - 后端新增操作类型时
 * - 后端修改操作类型时
 * - 业务新增审计场景时
 * 
 * ✅ 验证方式：
 * 让AI执行以下检查：
 * 1. 读取 backend/app/Models/SystemAuditLog.php
 * 2. 找到 getActionTextAttribute 方法中的 $actions 数组
 * 3. 检查枚举值是否与后端一致
 * 4. 检查是否有遗漏或多余的枚举值
 * 
 * @module types/audit-log/enums
 * @generated Manual (AI-assisted)
 * @last-updated 2025-10-18
 * ============================================================================
 */

/**
 * 审计操作类型
 * 
 * 对应后端 SystemAuditLog::getActionTextAttribute() 方法中定义的操作类型
 */
export enum AuditAction {
  /** 创建 */
  CREATE = 'create',
  
  /** 修改 */
  UPDATE = 'update',
  
  /** 删除 */
  DELETE = 'delete',
  
  /** 查看 */
  VIEW = 'view',
  
  /** 导出 */
  EXPORT = 'export',
  
  /** 导入 */
  IMPORT = 'import',
  
  /** 审批 */
  APPROVE = 'approve',
  
  /** 驳回 */
  REJECT = 'reject',
  
  /** 提交 */
  SUBMIT = 'submit',
  
  /** 取消 */
  CANCEL = 'cancel',
}

